//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["active"],
  data: function () {
    return {
      tabList: [
        {
          value: 1,
          name: "首页",
          img: require("../img/home.png"),
          imged: require("../img/homed.png"),
        },
        {
          value: 2,
          name: "项目",
          img: require("../img/project.png"),
          imged: require("../img/projected.png"),
        },
        {
          value: 3,
          name: "找人",
          img: require("../img/zhaoren.png"),
          imged: require("../img/zhaorened.png"),
        },
        {
          value: 4,
          name: "知识库",
          img: require("../img/knowledge.png"),
          imged: require("../img/knowledged.png"),
        },

        {
          value: 5,
          name: "我的",
          img: require("../img/mine.png"),
          imged: require("../img/mined.png"),
        },
      ],
    };
  },

  methods: {
    //底部导航跳转
    tabClick(val) {
      if (val == 1) {
        //首页
        this.$router.replace({
          path: "/",
        });
      }
      if (val == 2) {
        //项目
        this.$router.replace({
          path: "/project",
        });
      }
      if (val == 3) {
        //找人
        this.$router.replace({
          path: "/person",
        });
      }
      if (val == 4) {
        //知识库
        this.$router.replace({
          path: "/knowledge/index",
        });
      }
       if (val == 5) {
        //个人中心
        var source= this.$route.query.source?this.$route.query.source:'7'
        this.$router.replace({
          path: "/person/index?source="+source,
        });
      }
    },
  },
  mounted: function () {},
};
